import React from 'react';
import LegacyAccordion, { AccordionProps } from './Accordion.legacy';
import AlphaAccordion from './Accordion.alpha';

const Component = process.env.IS_LEGACY ? LegacyAccordion : AlphaAccordion;
export default Component as React.FC<AccordionProps>;
export type { AccordionProps };
